import { render } from "./SocialNetworksView.vue?vue&type=template&id=72a75ca4&scoped=true"
import script from "./SocialNetworksView.vue?vue&type=script&lang=js"
export * from "./SocialNetworksView.vue?vue&type=script&lang=js"

import "./SocialNetworksView.vue?vue&type=style&index=0&id=72a75ca4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a75ca4"]])

export default __exports__